// src/try/trial.ts: the public test ride in the browser (docs/DECISIONS.md "Public demo (try.homebuild.ai)"). Where it
// runs (site.trial), every visitor has a private copy of Harbor & Pine, opened by the landing's form; photos come
// from the sample library instead of the device; and the tour's stops and parts are reported so the owner's summary
// can say what the visitor reached. Nothing here does anything outside the test ride.
import { signal } from "@preact/signals";
import { api } from "../lib/api";
import { site } from "../state/session";

/** The test ride runs here. */
export function isTrial(): boolean {
  return !!site.value?.trial;
}

/** This browser has a live copy (the landing's form was sent within the last 24 hours). */
export function hasCopy(): boolean {
  return !!site.value?.trial?.copy;
}

// ------------------------------------------------------------------ the sample library

/** The library is open for this board (and this room, when Add Photos was pressed inside one). */
export const sampleLibrary = signal<{ pid: string; roomId: string | null; roomName: string | null } | null>(null);

export function openSamples(pid: string, room: { id: string; name: string } | null = null): void {
  sampleLibrary.value = { pid, roomId: room?.id ?? null, roomName: room?.name ?? null };
}

export const UPLOADS_OFF = "Uploads are off in the test ride. Add photos from the sample library.";

// ------------------------------------------------------------------ what the visitor reached

const queued = new Set<string>();
const sent = new Set<string>();
let timer: ReturnType<typeof setTimeout> | null = null;

/** Reports a tour stop ("stop:photos") or part ("chapter:2") once per page load, batched. Test ride only. */
export function reach(name: string): void {
  if (!hasCopy() || sent.has(name)) return;
  queued.add(name);
  sent.add(name);
  if (timer) return;
  timer = setTimeout(() => {
    timer = null;
    const names = [...queued].slice(0, 12);
    queued.clear();
    void api.tryEvents({ names }).catch(() => undefined);
  }, 800);
}
